import { makeStyles } from 'tss-react/mui'

export const useStyles = makeStyles()(theme => {
  return {
    root: {
      width: '100%',
    },
    legendsWrapper: {
      marginTop: theme.spacing(2.5),
    },
    responsiveLineWrapper: {
      display: 'flex',
      height: theme.spacing(24.75),
      marginTop: theme.spacing(2),
    },
    tooltip: {
      background: theme.palette.labraText.tertiary,
      color: theme.palette.text.white,
      width: 'fit-content',
      padding: theme.spacing(0.5, 1),
      display: 'flex',
      alignItems: 'center',
      gap: theme.spacing(1),
      minHeight: theme.spacing(3),
      borderRadius: theme.spacing(0.5),
    },
  }
})
